import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';

import { Date } from 'apps/components/date';
import Paragraph from 'components/Paragraph';

import {
  CardWrapper,
  CreatorAvatar,
  ContentWrapper,
  ContentRowWrapper,
} from 'apps/notificationCenter/styles';

const BaseCardCore = props => {
  const {
    headerStore,
    isActionable,
    routerStore,
    notification,
    message,
  } = props;
  if (!notification) return null;
  const { author, when, read, type, targetApp } = notification;

  const handleClick = e => {
    if (e?.target?.tagName === 'A') {
      if (headerStore) headerStore.HideNotifDropdown();
      return;
    }

    if (isActionable) return;

    switch (type) {
      case 'FOLLOWED':
        if (routerStore) {
          routerStore.navigate(author?.route?.name, author?.route?.params);
        }
        break;
      case 'COMMENTED':
      default:
        if (routerStore) {
          routerStore.navigate(
            targetApp?.route?.name,
            targetApp?.route?.params,
          );
        }
    }
    if (headerStore) headerStore.HideNotifDropdown();
  };

  return (
    <CardWrapper
      isRead={read}
      isActionable={isActionable}
      onClick={handleClick}
    >
      {author && (
        <Link {...author?.route}>
          <CreatorAvatar
            size='small'
            src={author.profile?.avatar?.url}
            name={author.profile?.fullName}
          />
        </Link>
      )}
      <ContentWrapper>
        <ContentRowWrapper>
          {author && (
            <Paragraph>
              <Link {...author?.route}>{author?.username}</Link>{' '}
            </Paragraph>
          )}
          {when && <Date value={when} />}
        </ContentRowWrapper>
        {message && <ContentRowWrapper>{message}</ContentRowWrapper>}
        {props.children}
      </ContentWrapper>
    </CardWrapper>
  );
};

BaseCardCore.defaultProps = {
  isActionable: false,
};

BaseCardCore.propTypes = {
  routerStore: PropTypes.object,
  headerStore: PropTypes.object,
  notification: PropTypes.object,
  message: PropTypes.node,
  isActionable: PropTypes.bool,
  children: PropTypes.node,
};

export default BaseCardCore;
